import React from 'react';
import { Button } from 'primereact/button';
import classes from '../../bidAnalysisTemplate.module.scss';

interface SectionHeaderProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  notesCount?: number;
  onNotesClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  sectionName?: string;
  children?: React.ReactNode;
  isManagerReviewMode?: boolean; // Show notes button only for managers in review mode
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  isExpanded,
  onToggle,
  notesCount,
  onNotesClick,
  sectionName: _sectionName,
  children,
  isManagerReviewMode: _isManagerReviewMode = false,
}) => {
  const handleNotesClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (onNotesClick) {
      onNotesClick(e);
    }
  };

  // Show notes button if onNotesClick is provided (available to everyone, not just in review mode)
  const shouldShowNotesButton = !!onNotesClick;

  return (
    <div className={classes.sectionHeader} onClick={onToggle}>
      <h2>{title}</h2>
      {shouldShowNotesButton && (
        <Button
          className={classes.notesBadge}
          onClick={handleNotesClick}
          label={`Review Notes (${notesCount || 0})`}
          text
          size="small"
          title="Click to view review notes"
        />
      )}
      {children}
      <i className={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`}></i>
    </div>
  );
};

